import React, { useState } from 'react';
import { Drawer, Button, Form, Input, message } from "antd";
import { getSaveRequest } from '../../redux/actions/obsAction';
import { connect } from "react-redux";


const reducer = ({ obs }) => ({ obs });
const Page = (props) => {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);

    const showDrawer = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onFinish = (values) => {
        console.log(values)
        props.dispatch(getSaveRequest(values)).then(c=>{
            if(!c.success){
                return message.warning(c.message, 5);
            }
            if(c.success){
                return message.success(c.message, 5);
            }
        })
    };

    return (
        <>
            <Button onClick={showDrawer} className='mx-2 bg-blue-500 text-white border-none'>Захиалга өгөх</Button>
            <Drawer
                title="Мэдээний захиалга"
                placement="right"
                onClose={onClose}
                width={500}
                open={open}
            >
                <Form layout="vertical" form={form} onFinish={onFinish}>
                    <Form.Item name="name" label="Нэр" rules={[{ required: true }]}>
                        <Input placeholder="Нэрээ оруулна уу" />
                    </Form.Item>

                    <Form.Item
                        name="email"
                        label="Имэйл"
                        rules={[
                        { required: true, message: "Имэйл оруулах ёстой!" },
                        { 
                            type: "email",
                            message: "Зөв имэйл хэлбэрээр оруулна уу!" 
                        },
                        ]}
                    >
                        <Input type="email" placeholder="exam@exam.com" />
                    </Form.Item>

                          {/* Утас */}
                    <Form.Item
                        name="phone"
                        label="Утас"
                        rules={[
                        { required: true, message: "Утасны дугаар оруулах ёстой!" },
                        { 
                            pattern: /^\d{8}$/,
                            message: "Утасны дугаар зөвхөн 8 оронтой тоо байх ёстой!" 
                        },
                        ]}
                    >
                        <Input placeholder="99******" />
                    </Form.Item>

                    <Form.Item name="aimag" label="Аймаг" rules={[{ required: true }]}>
                        <Input placeholder="Жишээ: Архангай" />
                    </Form.Item>

                    <Form.Item name="sum" label="Сум/Дүүрэг" rules={[{ required: true }]}>
                        <Input placeholder="Жишээ: Булган сум" />
                    </Form.Item>

                    <Form.Item name="type" label="Мэдээний төрөл" rules={[{ required: true }]}>
                        <Input placeholder="Жишээ: Цаг уур, Усны мэдээ гэх мэт" />
                    </Form.Item>

                    <Form.Item name="element" label="Элементийн төрөл" rules={[{ required: true }]}>
                        <Input placeholder="Жишээ: агаарын температур, голын түвшний гэх мэт" />
                    </Form.Item>

                    <Form.Item name="dateRange" label="Хамрах хугацаа" rules={[{ required: true }]}>
                        <Input placeholder="Жишээ: 2026-04-01 ~ 2026-04-10" />
                    </Form.Item>

                    <Form.Item name="description" label="Дэлгэрэнгүй">
                        <Input.TextArea rows={4} placeholder="Нэмэлт тайлбар..." />
                    </Form.Item>

                    <Button htmlType="submit" className='mx-2 bg-blue-500 text-white border-none' block>
                        Илгээх
                    </Button>
                </Form>
            </Drawer>
        </>
    )
}

export default connect(reducer)(Page);